import { jsx } from 'panel';
import { ActionsPopoverEl } from 'common/widgets/actions-popover';
import { AnnotationsMixin } from './annotations/template';
export function template() {
  var _a;

  const Annotations = AnnotationsMixin.bind(this);
  return jsx("div", {
    sel: '.root'
  }, jsx("div", null, this.attr("show-annotations") && this.state.annotations ? jsx(Annotations, null) : null), this.attr("show-popover") && ((_a = this.state.popover) === null || _a === void 0 ? void 0 : _a.isActive) ? jsx(ActionsPopoverEl, {
    on: Object.assign(Object.assign({}, this.popover().eventHandlers()), this.helpers.popover.props),
    style: this.helpers.popover.style(),
    attrs: Object.assign(Object.assign({}, this.popover().attrs()), this.helpers.popover.attrs())
  }, this.popover().body()) : null);
}